import React from "react";
import { T } from "../../app/tokens.js";

const STATUS_MAP = {
  on_track: { bg: T.ragGreenBg, fg: T.ragGreenText, border: T.ragGreenBorder, label: "On Track" },
  at_risk: { bg: T.ragAmberBg, fg: T.ragAmberText, border: T.ragAmberBorder, label: "At Risk" },
  off_track: { bg: T.ragRedBg, fg: T.ragRed, border: T.ragRedBorder, label: "Off Track" },
  complete: { bg: T.blueSoft, fg: T.blue, border: T.blueSoftBorder, label: "Complete" },
};

export function OkrStatusBadge({ status }) {
  const s = STATUS_MAP[status] || STATUS_MAP.on_track;
  return (
    <span
      data-testid={`okr-status-${status}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "2px 6px",
        borderRadius: 4,
        fontSize: T.fsXxs5,
        fontWeight: T.fwBold,
        textTransform: "uppercase",
        letterSpacing: "0.03em",
        background: s.bg,
        color: s.fg,
        border: `1px solid ${s.border}`
      }}
    >
      {s.label}
    </span>
  );
}
